<template>
  <Row class-name="c-cond-item" :gutter="12">
    <Col span="8">
      <Select v-model="currenthold">
        <Option v-for="drop in dropmenu" :key="drop.value" :value="drop.value">{{ drop.label }}</Option>
      </Select>
    </Col>
    <Col span="4">
      <Select v-model="equalhold">
        <Option v-for="drop in dropequal" :key="drop.value" :value="drop.value">{{ drop.label }}</Option>
      </Select>
    </Col>
    <Col span="8" class-name="m-conditon-wrap">
      <div class="m-conditon" v-if="fieldType === 'string' && !['==', '<>'].includes(equalhold)">
        <Input class="m-value" v-model.trim="threshold" @on-blur="toFloat" />
        <span class="m-unit">{{ unit }}</span>
      </div>
      <el-select
        v-else-if="fieldType === 'selecollapse'"
        v-model="threshold"
        filterable
        multiple
        collapse-tags
        :popper-append-to-body="false"
        style="width: 244px"
        placeholder="请选择"
      >
        <el-option v-for="drop in enumProperty" :key="drop.value" :label="drop.label" :value="drop.value"> </el-option>
      </el-select>
      <div class="m-conditon" v-else-if="equalhold === '<>'">
        <input-range v-model="threshold" :min="1" :max="99999999" :step="99999999" />
        <span class="m-unit">{{ unit }}</span>
      </div>
      <Select v-else v-model="threshold" style="width: 244px">
        <Option v-for="drop in enumProperty" :key="drop.value" :value="drop.value">{{ drop.label }}</Option>
      </Select>
      <div class="c-col-msg" v-if="msg">
        <span>{{ msg }}</span>
      </div>
    </Col>
    <Col span="4">
      <div class="m-trash" v-if="trash">
        <Icon type="ios-trash" size="25" color="#ff635c" @click.stop="$emit('on-delete')" />
      </div>
    </Col>
  </Row>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { isEmpty } from '@/common/js/utils'
import InputRange from '@/components/input/input-number-range'
export default {
  name: 'condItem',
  components: { InputRange },
  props: {
    value: {
      type: [Number, String, Array]
    },
    name: {
      type: String
    },
    current: {
      type: Number
    },
    dropmenu: {
      type: Array
    },
    dropequal: {
      type: Array
    },
    equal: {
      type: String
    },
    unit: {
      type: String
    },
    trash: {
      type: Boolean,
      default() {
        return true
      }
    },
    index: {
      type: Number
    },
    verify: {
      type: Boolean
    },
    fieldType: {
      type: String
    },
    enumProperty: {
      type: Array,
      default() {
        return []
      }
    },
    fixed: {
      type: Boolean,
      default() {
        return false
      }
    },
    precision: {
      type: Number
    }
  },
  computed: {
    currenthold: {
      get() {
        return this.current
      },
      set(val) {
        this.$emit('on-change', {
          current: val,
          equal: this.equalhold,
          index: this.index
        })
      }
    },
    threshold: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    equalhold: {
      get() {
        return this.equal
      },
      set(val) {
        this.$emit('on-change', {
          current: this.current,
          equal: val,
          index: this.index
        })
      }
    },
    msg() {
      let msgTxt = ''
      const ignoreMax = ['payCount'] // 不验证最大限制
      if (this.verify && isEmpty(this.threshold)) msgTxt = '该项不能为空'
      else if (this.verify && !ignoreMax.includes(this.name) && Number(this.threshold) >= 100000000) {
        msgTxt = `该项最大值为${this.fixed ? '99999999.99' : '99999999'}`
      }
      return msgTxt
    }
  },
  methods: {
    toFloat() {
      if (isEmpty(this.threshold)) return
      let val
      if (this.fixed) {
        const precision = this.precision || 2
        const multiple = new Array(precision).fill(10)
        const times = multiple.reduce((ret, sum) => ret * sum, 1)
        val = parseFloat(this.threshold)
        if (val >= 0 && precision) {
          val = mul(val, times)
          val = div(Math.floor(val), times)
        } else val = 0
      } else {
        val = parseInt(this.threshold)
        if (val < 0) val = 0
      }
      this.$set(this, 'threshold', String(val))
    }
  }
}
</script>
<style lang="scss" scoped>
.c-cond-item {
  width: 100%;
  margin-bottom: 20px;

  .m-conditon-wrap {
    position: relative;
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 8px;
    bottom: -16px;
    color: #ff4400;
  }

  .m-conditon {
    width: 100%;
    display: flex;
    flex-direction: row;

    .m-value {
      width: 88%;
      flex: 0 0 auto;
    }

    .m-unit {
      display: inline-block;
      width: 12%;
      min-width: 24px;
      flex: 0 0 12%;
      text-align: right;
      line-height: 32px;
    }
  }

  .m-trash {
    line-height: 32px;
    padding-left: 24px;
    cursor: pointer;
  }

  ::v-deep .el-input {
    .el-input__inner,
    .el-input__icon {
      height: 32px;
      line-height: 32px;
    }
  }

  ::v-deep .el-select__tags-text {
    max-width: 110px;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    vertical-align: middle;
  }
}
</style>
